export default __webpack_public_path__ + "static/media/three-dots.b98a8c76.svg";